import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import FrCloseSmallSvg from '@src/svgs/fr-close-small.svg';
import { HideProps } from './props';
import './styles.scss';

export const Hide: FC<HideProps> = ({ onHide }) => {
  return (
    <div
      className="featured-applicant-hide"
      onClick={event => {
        event.stopPropagation();
        onHide();
      }}
    >
      <Svg className="featured-applicant-hide__action-icon" src={FrCloseSmallSvg} />
      Hide
    </div>
  );
};
